// src/components/ServicePlanCard.js
import React from "react";
import styles from "./ServicePlanCard.module.css";
import * as actions from "../../actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { FaRedo } from "react-icons/fa";

const getProductTitle = (type) => {
  const titles = {
    eSIM: "eSIM",
    Recharge: "Recharge",
  };
  return titles[type] || "Service Plan";
};

const ServicePlanCard = ({
  id,
  product,
  isoCode,       // 2-letter ISO from region's linked country; null = no country
  regionName,
  regionImage,
  isRenew,
  productType,
  price,
  details,
  history,
  auth,
  onBuyClick,
}) => {
  const title = getProductTitle(productType);
  const imgSrc =
    regionImage
      ? regionImage
      : isoCode
        ? `https://flagcdn.com/${isoCode}.svg`
        : `${process.env.PUBLIC_URL}/flag.png`;

  const handleBuyClick = () => {
    if (onBuyClick) {
      onBuyClick(product);
    }
  };

  const handleDetailsClick = () => {
    history.push({ pathname: `/home/productDetail/${id}` });
  };

  // If region has a linked country with a valid ISO code, show that country's flag.
  // Otherwise (NULL country) show the default flag.png.
  const flagSrc =
    isoCode
      ? `https://flagcdn.com/${isoCode}.svg`
      : `${process.env.PUBLIC_URL}/flag.png`;

  return (
    <div className={styles.planCard}>
      <div className={styles.cardHeader}>
        <div className={styles.countryInfo}>
          <img
            src={imgSrc}
            alt={regionName || "flag"}
            className={styles.flagIcon}
            onError={(e) => {
              e.target.src = `${process.env.PUBLIC_URL}/flag.png`;
            }}
          />
        </div>
        <div className={styles.regionBadge}>{regionName || "N/A"}</div>
      </div>

      <div className={styles.planDetails}>
        {details.map((detail, index) => (
          <p key={index}>{detail}</p>
        ))}
        <div className={styles.productTitle}>
          {title}{" "}
          {isRenew && (
            <span className={styles.renewBadge} title="Renewable">
              <FaRedo className={styles.renewIcon} />
              <span>Renewable</span>
            </span>
          )}
        </div>
      </div>

      <div className={styles.price}>{price}</div>

      <div className={styles.buttons}>
        <button className={styles.btnPrimary} onClick={handleBuyClick}>
          Buy Now
        </button>
        <button className={styles.btnSecondary} onClick={handleDetailsClick}>
          Details
        </button>
      </div>
    </div>
  );
};

export default ServicePlanCard;